import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../ui/DropdownMenu";

import NavTooltip from "../../component/navigation/NavTooltip";

interface NavDropdownProps {
    icon: any;
    toggleTheme: (theme: Theme) => void;
    currentTheme: Theme;
    isOpen: boolean;
}

export type Theme = "light" | "dark" | "system";

export default function NavDropdown({
    icon,
    toggleTheme,
    currentTheme,
    isOpen,
}: NavDropdownProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <div
                    className={`flex items-center px-1 py-1 rounded-md hover:bg-[#C6C5C5] dark:hover:bg-gray-700 duration-300 outline-none ${
                        isOpen ? "w-[230px] gap-4" : "w-fit"
                    }`}
                >
                    {isOpen ? (
                        <>
                            {icon}
                            <span className="text-[15px] font-semibold text-gray-700 dark:text-gray-300">
                                Theme
                            </span>
                        </>
                    ) : (
                        <NavTooltip name="Theme" icon={icon} />
                    )}
                </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="flex flex-col"
                side="right"
            >
                <DropdownMenuItem
                    onClick={() => toggleTheme("light")}
                    className={`${
                        currentTheme === "light"
                            ? "bg-gray-300 text-black"
                            : ""
                    }`}
                >
                    Light
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => toggleTheme("dark")}
                    className={`${
                        currentTheme === "dark"
                            ? "dark:bg-gray-800 dark:text-white"
                            : ""
                    }`}
                >
                    Dark
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => toggleTheme("system")}
                    className={`${
                        currentTheme === "system"
                            ? "bg-gray-300 text-black dark:bg-gray-800 dark:text-white"
                            : ""
                    }`}
                >
                    System
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
